import React from 'react'
import schema from '../jsonschemas/icu_order_1/icu_o1.schema.json'
import uiSchema from '../jsonschemas/icu_order_1/icu_o1.ui.json'
import { FormPreview } from './FormPreview'

export function TestSchemaICUOrder1() {
  return <FormPreview schema={schema} uiSchema={uiSchema} />
}
